import './ScoreBoard.css';

const ScoreBoard = ({ scoreX, scoreO, turn }) => (
    <div className="score-board">
        <div className={`sb-side sb-x${turn === 'X' ? ' sb-active' : ''}`}>
            <span className="sb-label">P1</span>
            <span className="sb-score">{scoreX}</span>
            {turn === 'X' && <span className="sb-turn-dot" />}
        </div>
        <div className="sb-divider">:</div>
        <div className={`sb-side sb-o${turn === 'O' ? ' sb-active' : ''}`}>
            {turn === 'O' && <span className="sb-turn-dot" />}
            <span className="sb-score">{scoreO}</span>
            <span className="sb-label">P2</span>
        </div>
    </div>
);

export default ScoreBoard;
